import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import Link from '@src/components/link';
import CdkModalStore from './store';
import TinyInput from '@src/components/tiny-input';
const styles = require('./index.less');

/**
 * 弹窗模板, 可以快速套用修改
 */
const CdkModal = ({ store, onClose }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={cx(styles.commonDemoModalRoot)}>
        <Link className={styles.closeBtn} onClick={store.onClickClose} />
        <div className={styles.modalContainer}>
          <div className={styles.title}>
            下载游戏，获取官方<span>[新岁启程补给]</span>
          </div>
          <div className={styles.desc}>{store.text_setting}</div>
          <div className={styles.rewards}>
            {store.rewards.map((item, index) => (
              <div key={index} className={styles.rewardItem}>
                <div className={styles.count}>{'x' + item.count}</div>
                <img className={styles['rewardIcon' + index]} src={item.icon} alt={item.name} />
                <div className={styles.name}>{item.name}</div>
              </div>
            ))}
          </div>
          <div className={styles.rules}>
            <div>注意：</div>
            <div>1. 礼包码获取时间：1月29日09:00~2月26日23:59，兑换有效期自更新后至2月27日23:59</div>
            <div>2. 每个手机号只能获得一个礼包码，同类礼包码每个账号限用一次</div>
            <div>3. 礼包码兑换方式：进入游戏-设置-其他设置-点击前往兑换，输入礼包码-点击确定</div>
            <div>4. 各渠道【新岁启程补给】礼包码互斥，仅能选择一个渠道进行礼包码兑换</div>
          </div>
          {store.KvSectionStore.openSendCode === 1 ? (
            <div className={styles.form}>
              <div className={cx(styles.formItem, styles.phone)}>
                <div className={styles.label}>请输入手机号//</div>
                <TinyInput store={store.phoneInput} />
              </div>
              <div className={cx(styles.formItem, styles.code)}>
                <div className={styles.label}>请输入验证码//</div>
                <TinyInput store={store.codeInput} />
              </div>
              <Link className={styles.sendCode} onClick={store.handleClickCode}>
                <div className={styles.btnText}>{store.countDownTimer ? `${store.countDown}s` : '发送验证码'}</div>
              </Link>
            </div>
          ) : (
            <div className={styles.empty}>新岁启程补给将于1月29日~2月26日开放领取</div>
          )}
        </div>
        <Link className={styles.confirm} onClick={store.confirm} />
      </div>
    </ModalContainer>
  );
};

export default wrapStore(CdkModal, CdkModalStore);
